
<template>
    <el-dialog title="选择角色" :visible.sync="updateRoleFormDialogVisible">
       <avue-form ref="roleForm" v-model="roleForm"  :option="formOption">
          <template slot-scope="scope" slot="menuForm">
              <el-button  @click="handleEmpty">取 消</el-button>
              <el-button type="primary" @click="select_role_true">确 定</el-button>
          </template>
      </avue-form>
    </el-dialog> 
</template>
<script>
  import {authRole} from '@/api/admin/user'
  import waves from '@/directive/waves/index.js' // 水波纹指令
  import {objKeySort} from '@/util/ajaxsign'
  export default {
    name: 'table_user',
    directives: {
      waves
    },
    data() {
      return {
        roleForm : {
          roleId:undefined,
          userId : undefined,
        },
        
        formOption:{
          emptyBtn:false,
          submitBtn:false,
          submitText : '确定',
          column: [{
            label: "角色",
            prop: "roleId",
            span:24,
            visdiplay : true,
            rules : [ { required: true, message: '请选择角色', trigger: 'blur'}],
            type: 'select',
            dicUrl : '/role/roleList',
            dicMethod:"post",
            dicQuery : objKeySort({}),
              props : {
                label: 'roleName',
                value: 'roleId'
            }
          }],
        },
        updateRoleFormDialogVisible : false,
      }
    },
    created() {},
    methods: {
      //设置用户id
      setuserid(userId,roleId){
        //debugger
        this.roleForm.userId = userId;
        //设置角色选中数据
        if(roleId)
          this.roleForm.roleId = parseInt(roleId);
        else
          this.roleForm.roleId = undefined;
        this.updateRoleFormDialogVisible = true;
      },
      // 确定分配角色
      select_role_true(){
        this.$refs.roleForm.validate(vaild=>{
          if(vaild){
            authRole(objKeySort({userId:this.roleForm.userId,roleId:this.roleForm.roleId })).then(response =>{
              this.$message({
                title: '分配成功',
                message: '分配成功',
                type: 'success',
                duration: 2000
              })
              this.handleEmpty();
              this.$emit('refresh','');
            })
          }
        })
      },
      
      
      handleEmpty(){
        this.updateRoleFormDialogVisible = false;
        this.$refs.roleForm.resetForm();
      }
    }
  }
</script>